import React from 'react'
import PropTypes from 'prop-types'

import { ContentWrapperContainer } from './Styles'

const ContentWrapper = ({ children, isCentered }) => (
  <ContentWrapperContainer isCentered={isCentered} data-testid="content-wrapper">
    {children}
  </ContentWrapperContainer>
)

ContentWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isCentered: PropTypes.bool
}

ContentWrapper.defaultProps = {
  isCentered: false
}

export default ContentWrapper
